import { toast } from "react-toastify";
import { AppDispatch } from "reducers";
import { UserType } from "utils/types";
import { AuthStateType } from "utils/types/reducer-types";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialUser: UserType = {
    id: '',
    amount: 0,
    level: 0,
    userName: '',
    language: '',
    limit: 300,
    from: 0,
    to: 2000,
    votedAmount: 0
}

const initialState: AuthStateType = {
    isLogin: false,
    user: initialUser,
    token: ''
}

export const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        updateLogin: (state: AuthStateType, action: PayloadAction<{ user: UserType, token: string }>) => {
            state.isLogin = true;
            state.user = { ...action.payload.user }
            state.token = action.payload.token
        },
        updateVote: (state: AuthStateType, action: PayloadAction<{ limit: number, from: number, to: number, amount: number, votedAmount: number, level: number }>) => {
            state.user.limit = action.payload.limit;
            state.user.from = action.payload.from;
            state.user.to = action.payload.to;
            state.user.amount = action.payload.amount;
            state.user.votedAmount = action.payload.votedAmount;
            state.user.level = action.payload.level;
        },
        updateAmountAndLevel: (state: AuthStateType,action: PayloadAction<{ amount: number, level: number }>) => {
            state.user.amount = action.payload.amount;
            state.user.level = action.payload.level;
        },
        logout: (state: AuthStateType) => {
            state.isLogin = false;
            state.user.temparary = true;
            state.user = { ...initialUser };
            state.token = '';
        }
    }
})

export const { updateLogin, updateVote, logout, updateAmountAndLevel } = authSlice.actions;

export default authSlice.reducer;
